module.exports = __webpack_public_path__ + "img/logn.2a118553.png";